import { createFileRoute } from '@tanstack/react-router';
import { AppRoute } from '@agentselly/immodossier-shared';
import { LoadingWidget } from '~/components/widget/base/LoadingWidget';
import { ErrorWidget } from '~/components/widget/base/ErrorWidget';
import { useAuth, useUser } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useAppParams } from '~/helper/useAppParams';

export const Route = createFileRoute(AppRoute.$LANG_$COMPANYID_INDEX)({
  component: Body,
});

function Body() {
  const navigate = Route.useNavigate();
  const params = useAppParams(Route);
  const user = useUser();
  const { getToken } = useAuth();

  useEffect(() => {
    async function redirect() {
      if (!user.isLoaded) {
        return;
      }

      if (!user.isSignedIn || !user.user) {
        await navigate({
          to: AppRoute.$LANG_$COMPANYID_PUBLIC_AUTH_LOGIN,
          params: params as any,
          search: {
            // FIXME: Weird ts issue
          } as any,
          // Redirect must replace, not push: a pushed entry becomes a phantom
          // that back() lands on, whose effect re-pushes forward → the "two
          // taps to go back" bug.
          replace: true,
        });
        return;
      }

      const contactId = user.user?.publicMetadata?.hubspotContactId as
        | string
        | undefined;

      const userCompanyId = user.user?.publicMetadata?.companyId as
        | string
        | undefined;

      const targetCompanyId = userCompanyId || params.companyId;

      if (contactId) {
        await navigate({
          to: AppRoute.$LANG_$COMPANYID_$CONTACTID_INDEX,
          params: {
            ...params,
            companyId: targetCompanyId,
            contactId,
          },
          // Replace (not push) so this redirect leaves no phantom history entry
          // that would otherwise require a second back-tap to skip past.
          replace: true,
        } as any);
      }
    }

    redirect().catch(console.error);
  }, [
    getToken,
    navigate,
    user,
    params,
  ]);

  if (
    user.isLoaded &&
    user.isSignedIn &&
    user.user &&
    !user.user.publicMetadata?.hubspotContactId
  ) {
    return (
      <ErrorWidget
        error={{ message: 'No contact ID found in user metadata' }}
      />
    );
  }

  return <LoadingWidget />;
}
